import { createApi } from '@reduxjs/toolkit/query/react'
import { apiClient } from '../../services/api'

const axiosBaseQuery =
  () =>
  async ({ url, method = 'GET', data, params, headers, signal, _skipAuth }) => {
    try {
      const result = await apiClient({
        url,
        method,
        data,
        params,
        headers,
        signal,
        _skipAuth,
      })
      return { data: result.data }
    } catch (axiosError) {
      return {
        error: {
          status: axiosError.response?.status,
          data: axiosError.response?.data ?? axiosError.message,
        },
      }
    }
  }

export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: axiosBaseQuery(),
  tagTypes: [
    'Auth',
    'Tasks',
    'Triggers',
    'KC',
    'KCStats',
    'Suggestions',
    'Notifications',
    'Discovery',
    'Memory',
    'Relics',
    'Templates',
    'Connections',
    'WorkspaceTasks',
  ],
  endpoints: () => ({}),
})
